import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'
import { roundedCorners } from '@utils'

export const CaseStudiesMain = styled.section`
  background-color: ${colors.white};
`

export const CaseStudiesWrapper = styled.div``

export const CaseStudiesHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  a {
    margin-bottom: 15px;
  }
`

export const CaseStudiesFooter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  a span {
    ${mq.mobileMax} {
      font-size: 20px;
      letter-spacing: normal;
    }
  }
`

export const CaseStudiesTitle = styled.h2`
  ${getCustomTextStyle(textStylesConfig.heading2Sans, textStylesConfig.heading3Serif)}
  max-width: 30rem;
  margin-right: auto;
  ${mq.tabletL} {
    max-width: 70rem;
  }
  ${mq.tabletPMax} {
    font-size: 28px;
  }
  a {
    margin-bottom: 15px;
  }
`

export const CaseStudyMain = styled.div`
    position: relative;
    a {
        text-decoration: none;
        width: 100%;
        &:before {
            position: absolute;
            content: "";
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 1;
        }
    }
    
    &:hover {
        .gatsby-image-wrapper {
            height: 360px !important;
        }
        .content {
            ${mq.tabletP} {
                transform: translateX(20px);
            }
        }
    }
    .content {
        ${mq.tabletL} {
            padding: 40px 30px 40px 0;
        }
        width: 60%;
        ${mq.tabletPMax} {
            width: 100%;
        }
    }
    .caseStudyContainer {
        display: flex;
        align-items: center;
        border-bottom:1px solid ${colors.mist};
    }
    
    .caseStudyImage {
        width: 25%;
        aspect-ratio: 1/1;
        max-width: 360px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin: -8% 0;
        ${mq.tabletPMax} {
            display: none;
        }
    }
    .gatsby-image-wrapper {
        position: absolute;
        transition: height 0.25s ease;
        height: 0 !important;
        max-height: 100%;
    }
    .arrowIcon {
        width: 40px;
    }
    
`

export const IconContainer = styled.div`
    width: 24px;
    margin: auto 20px 40px auto;
    ${mq.tabletPMax} {
        width: 16px;
        margin: auto 20px 30px auto;
    }
`

export const CaseStudyImage = styled.div`
`

export const CaseStudyContent = styled.div`
    position: relative;
    z-index: 1;
    
    ${mq.tabletPMax} {
        padding: 25px 15px;
    }
    p {
        line-height: 30px;
    }
    transition: all 0.25s ease;
    .title {
        margin-top: 10px;
        strong {
            font-weight: normal;
            font-family: Signifier;
        }
        ${mq.tabletPMax} {
            br {
                display: none;
            }
            h4{
                font-size: 14px;
            }
        }
    }
`

export const CaseStudyContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-end;
    position: relative;
`

export const DisplayButton = styled.span`
    display: flex;
    position: relative;
    border: 1px solid ${colors.charcoal};
    border-radius: 7rem;
    cursor: pointer;
    background: ${colors.white};
    &.active {
        .backArea {
            left: 65px;
        }
        .grid {
            color: ${colors.white}
        }
        .list {
            color: ${colors.charcoal}
        }
    }
`

export const BackArea = styled.div`
    display: flex;
    position: absolute;
    height: 100%;
    left: 0;
    border-radius: 7rem;
    width: 76px;
    background: ${colors.charcoal};
    transition: all 0.25s ease;
`

export const DisplayLabel = styled.div`
    padding: 7px 0px;
    width: 70px;
    text-align: center;
    position: relative;
    transition: all 0.25s ease;
    &.grid {
        color: ${colors.charcoal}
    }
    &.list {
        color: ${colors.white}
    }
`

export const CMSButtonContainer = styled.div`
    width: 15%;
`
